import { FC } from 'react';
import { withStyles, Card } from 'vopay';
import { useHistory } from 'react-router-dom';
import { Title, Button } from 'UI';
import { ClientAccountList } from 'shared/clientAccountList';
import { useTranslation } from 'react-i18next';
import styles from './ClientAccountsPage.module.scss';
import useClientAccountListHostProps from './useClientAccountListHostProps';
import { usePermissions } from '@/providers/Permissions.provider';

const cn = withStyles(styles);

// Host chrome for the /client-accounts route (ID-13350). The filters + table + paginator now live in the
// shared ClientAccountList feature; the host owns only the page header and the white Card around it, plus
// mapping its own model onto the feature's props (useClientAccountListHostProps). The container stays
// host-side on purpose so each host can wrap the list its own way.
const ClientAccountsPage: FC = () => {
  const history = useHistory();
  const hostProps = useClientAccountListHostProps();
  const { permissions } = usePermissions();
  const { t } = useTranslation('translations', { keyPrefix: 'ClientAccounts' });

  return (
    <div className={cn('clientAccountsPage')}>
      <header className={cn('pageHeader')}>
        <Title>{t('pageTitle', { defaultValue: 'Client Accounts' })}</Title>

        {permissions.ManageClientAccounts && (
          <Button
            colorScheme="primary"
            iconLeft="add"
            onClick={() => history.push('/client-accounts/create', { showBackButton: true })}
          >
            {t('addClientAccount', { defaultValue: 'Add Client Account' })}
          </Button>
        )}
      </header>

      <Card
        style={{
          padding: '16px',
        }}
      >
        <ClientAccountList {...hostProps} />
      </Card>
    </div>
  );
};

export default ClientAccountsPage;
